import { render, staticRenderFns } from "./EditorChat.vue?vue&type=template&id=7909ce05"
import script from "./EditorChat.vue?vue&type=script&lang=js"
export * from "./EditorChat.vue?vue&type=script&lang=js"
import style0 from "./EditorChat.vue?vue&type=style&index=0&id=7909ce05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports